import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowRight } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const categoryLabels = { institutionnel: 'Partenaires Institutionnels', officiel: 'Partenaires Techniques', sponsor: 'Sponsors', media: 'Partenaires Média' };
const categoryOrder = ['institutionnel', 'officiel', 'sponsor', 'media'];

const Partenaires = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/partenaires`).then(r => setPartners(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const grouped = categoryOrder.map(cat => ({ key: cat, label: categoryLabels[cat] || cat, items: partners.filter(p => p.category === cat) })).filter(g => g.items.length > 0);

  return (
    <div className="min-h-screen pt-16">
      {/* PAGE HERO */}
      <section className="relative py-24 lg:py-32 bg-[#1E3A5F] overflow-hidden" data-testid="partenaires-hero">
        <div className="relative container-institutional">
          <p className="text-sm font-semibold uppercase tracking-widest text-[#F5A623] mb-4">Partenaires</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">Ils nous font confiance</h1>
          <p className="text-lg text-white/70 max-w-2xl leading-relaxed">URBANIK 2026 rassemble les acteurs clés du secteur du BTP. Institutions, organismes techniques, sponsors et médias s'engagent ensemble.</p>
        </div>
      </section>

      {/* PARTNER GRID */}
      <section className="py-20 lg:py-28" data-testid="partner-grid-section">
        <div className="container-institutional">
          {loading ? <p className="text-center text-[#94A3B8] py-16">Chargement...</p> : grouped.length === 0 ? (
            <p className="text-center text-[#94A3B8] py-16">Aucun partenaire pour le moment.</p>
          ) : (
            <div className="space-y-24">
              {grouped.map(group => (
                <div key={group.key} data-testid={`partner-group-${group.key}`}>
                  <div className="text-center mb-12">
                    <h2 className="text-2xl font-bold text-[#1E3A5F] mb-2">{group.label}</h2>
                    <div className="w-10 h-0.5 bg-[#F5A623] rounded-full mx-auto mt-3" />
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 items-stretch justify-items-stretch">
                    {group.items.map(partner => (
                      <div key={partner.id} className="flex items-center justify-center p-4 bg-white border border-[#E1E8F0] rounded-lg hover:shadow-md hover:border-[#F5A623]/40 transition-all w-full h-40 sm:h-44" data-testid={`partner-${partner.id}`}>
                        <img src={partner.logo_url} alt={partner.name} className="max-h-32 sm:max-h-36 max-w-full w-auto object-contain" title={partner.name} />
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 lg:py-28 bg-[#1E3A5F]" data-testid="partenaires-cta">
        <div className="container-institutional text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Devenez Partenaire</h2>
          <p className="text-white/70 max-w-xl mx-auto mb-8">Associez votre image à l'événement de référence du BTP en Côte d'Ivoire.</p>
          <Link to="/exposition/devenir-exposant" className="btn-primary text-base px-8 py-4">Nos Offres <ArrowRight className="w-5 h-5 ml-2" /></Link>
        </div>
      </section>
    </div>
  );
};

export default Partenaires;
